import { useEffect, useRef } from "react";
import { Link, useLocation } from "wouter";
import "@/components/marketing/marketing.css";
export default function Navigation() {
  const [path] = useLocation();
  const menu = useRef<HTMLDetailsElement>(null);
  useEffect(() => { if (menu.current) menu.current.open = false; }, [path]);
  const landing = path === "/ai-sales" || path === "/scorecard";
  return (
    <header
      className="growth"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        borderBottom: "1px solid #dce3dd",
      }}
    >
      <nav className="wrap nav" aria-label="Main navigation">
        <Link href="/" className="brand" aria-label="Better Systems AI home">
          <span className="brandmark" aria-hidden="true">
            b.
          </span>
          Better Systems{" "}
          <span style={{ color: "#64806b", fontWeight: 400 }}>AI</span>
        </Link>
        {landing ? (
          <span className="small">Your business. Working better.</span>
        ) : (
          <>
            <div className="navlinks">
              <Link href="/services">What we do</Link>
              <Link href="/work">Our work</Link>
              <Link href="/about">About</Link>
              <Link href="/book" className="btn">
                Let’s talk
              </Link>
            </div>
            <details ref={menu} className="mobilemenu" onKeyDown={(event) => { if (event.key === "Escape" && menu.current) { menu.current.open = false; menu.current.querySelector("summary")?.focus(); } }}>
              <summary>Menu</summary>
              <div>
                <Link href="/services">What we do</Link>
                <Link href="/work">Our work</Link>
                <Link href="/about">About</Link>
                <Link href="/ai-sales">Free AI plan</Link>
                <Link href="/book">Let’s talk</Link>
              </div>
            </details>
          </>
        )}
      </nav>
    </header>
  );
}
